import service from '@/middleware'

const workFrontApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     * @param {*} enterpriseIds
     */
    async findAll(pageSize, pageNumber, headers, enterpriseIds) {
        const url = pageSize != null && pageNumber != null
            ? `/api/work-front/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/work-front/all?headers=${headers}`
        const response = await service.http.post(url, enterpriseIds)
        return response
    },
    /**
     * Total de frente de trabajos para el paginador de la tabla del ABM
     * @param {*} enterpriseIds
     */
    async getTotal (enterpriseIds) {
        const result = await service.http.post(`/api/work-front/total`, enterpriseIds)
        return result
    },
    /**
     * Para obtener un frente de trabajo con el id enviado como param
     * @param {*} workFrontId
     */
    async getWorkFront (workFrontId) {
        const result = await service.http.get(`/api/work-front/${workFrontId}`)
        return result
    },
    /**
     * Para obtener los frente de trabajos con el enterpriseId enviado como parámetro
     * @param {*} enterpriseId
     */
    async getWorkFrontsByEnterpriseId (enterpriseId) {
        const result = await service.http.get(`/api/work-front/by-enterprise/${enterpriseId}`)
        return result
    },
    /**
     * Para validar el nombre de un frente de trabajo
     * @param {*} name
     */
    async validateWorkFrontName (name, enterpriseId) {
        const result = await service.http.get(`/api/work-front/validate-name/${name}/${enterpriseId}`)
        return result
    },
    /**
     * Para crear un nuevo frente de trabajo
     * @param {*} workFrontDto
     * @param {*} thingIds
     */
    async create (workFrontDto, thingIds) {
        const result = await service.http.post(`/api/work-front/create`, { workFrontDto, thingIds })
        return result
    },
    /**
     * Para actualizar un frente de trabajo
     * @param {*} workFrontDto
     * @param {*} thingIds
     */
    async update (workFrontDto, thingIds) {
        const result = await service.http.put(`/api/work-front/update`, { workFrontDto, thingIds })
        return result
    },
    /**
     * Para eliminar un frente de trabajo
     * @param {*} id
     */
    async deleteOne (id) {
        const result = await service.http.delete(`/api/work-front/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteMany (ids) {
        const result = await service.http.put(`/api/work-front/multiple-delete`, ids)
        return result
    },
    /**
     * Obtener las frente de trabajos
     */
    async getAll () {
        const result = await service.http.get(`/api/work-front/all`)
        return result
    },
    async getStoreroomByWorkfrontId(enterpriseId, workFrontId) {
        const result = await service.http.post(`/api/work-front/storeroom-by-work-front-id`, { enterpriseId, workFrontId });
        return result;
    }
}

export default workFrontApi
